import { ICommandBase } from '@/commands/interface/iCommandBase';
import { ExTextLayer } from '@/model/document2/page/surface/design/layer/exTextLayer';
import { TextInfo } from '@/utilityModels/textInfo';

// 通常テキストレイヤーの文法情報範囲変更コマンド
export class ChangePlainTextLayerRangeTextInfoCommand implements ICommandBase
{
    private layer! : ExTextLayer;
    private textInfoArray! : Array<TextInfo>;
    private startPosition : number;
    private endPosition : number;
    private doneCallback! : () => void;

    private oldTextInfoArray;
    private oldBaseTextInfo;

    constructor(layer : ExTextLayer, textInfoArray : Array<TextInfo>, startPosition : number, endPosition : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.textInfoArray = textInfoArray;
        this.startPosition = startPosition;
        this.endPosition = endPosition;
        this.doneCallback = doneCallback;

        // 現在の値を保持
        this.oldTextInfoArray = layer.textInfoArray;
        this.oldBaseTextInfo = layer.baseTextInfo;
    }

    public do() : void
    {
        // 新しい値を設定
        var range = this.layer.getLineAndCharacterIndexArrayFromPositionRange(this.startPosition, this.endPosition);
        for(var i = 0; i < range.length ; ++i)
        {
            var indexPair = range[i];
            var textInfo = i < this.textInfoArray.length ? this.textInfoArray[i] : this.layer.baseTextInfo;
            var info = this.layer.getCharacterInfo(indexPair.lineIndex, indexPair.characterIndex);
            if(info != null)
            {
                var index = info.index;
                this.layer.replaceTextInfo(textInfo.clone(), index);
            }
        }
        // baseTextInfoを、最初の文字と同じtextInfoに差し替える
        if(this.layer.textInfoArray.length > 0)
        {
            this.layer.baseTextInfo = this.layer.textInfoArray[0].clone();
        }

        this.doneCallback();
    }

    public undo() : void
    {
        // プロパティに前の値を設定
        this.layer.textInfoArray = this.oldTextInfoArray;
        this.layer.baseTextInfo = this.oldBaseTextInfo;

        this.doneCallback();
    }

    public redo() : void
    {
        // 新しい値を設定
        var range = this.layer.getLineAndCharacterIndexArrayFromPositionRange(this.startPosition, this.endPosition);
        for(var i = 0; i < range.length ; ++i)
        {
            var indexPair = range[i];
            var textInfo = i < this.textInfoArray.length ? this.textInfoArray[i] : this.layer.baseTextInfo;
            var info = this.layer.getCharacterInfo(indexPair.lineIndex, indexPair.characterIndex);
            if(info != null)
            {
                var index = info.index;
                this.layer.replaceTextInfo(textInfo.clone(), index);
            }
        }
        // baseTextInfoを、最初の文字と同じtextInfoに差し替える
        if(this.layer.textInfoArray.length > 0)
        {
            this.layer.baseTextInfo = this.layer.textInfoArray[0].clone();
        }

        
        this.doneCallback();
    }
}